export const secondSection = [
  {name: "Necessidade 75 dias", translation: 'P.H Requirement'},
  {name: "Criticar", translation: 'Critical'},
  {name: "Suficiência", translation: 'Out Of Stock' },
  {name: "Próximo Pedido", translation: 'Next Order'},
  {name: "Status", translation: 'Status'},
  {name: "Dia Falta", translation: 'OOS Date'},
  {name: "Justificativa",translation: 'Justification'}
]
